<!--  -->
<template>
  <div class="submit-code-exercise-content">
    <!-- 提交代码、提交题面按钮  -->
    <section class="submit-code-exercise">
      <div
        @click="submitCode(buildingBlocksTypeObj.answer)"
        :class="{ dispermited: scoreHandle }"
        class="submit-btn"
      >
        <img class="icon-project" :src="iconSubmitCode" />
        <span class="text" :class="{ 'events-disable': running }">{{
          userRole == 2 && submitShow ? '实训报告' : '提交代码'
        }}</span>
      </div>
      <div
        v-if="userRole != 2"
        @click="saveFile(buildingBlocksTypeObj.question)"
        class="submit-btn exercise-btn"
        :class="{ dispermited: scoreHandle }"
      >
        <!-- :class="{ dispermited: scoreHandle }" -->
        <img class="icon-project" :src="iconExercise" />
        <span class="text">{{ '提交题面' }}</span>
      </div>
      <div
        v-if="userRole === 2"
        @click="saveFile(buildingBlocksTypeObj.answer)"
        class="submit-btn exercise-btn"
      >
        <img class="icon-project" :src="iconExercise" />
        <span class="text">{{ '保存为解法' }}</span>
      </div>
      <!-- 评分按钮 -->
      <div
        v-if="userRole != 2 && scoreHandle"
        @click="socreProject2()"
        class="submit-btn exercise-btn"
      >
        <img class="icon-project" :src="iconExercise" />
        <span class="text">{{ scoreShow ? '实训报告' : '评分' }}</span>
      </div>
    </section>

    <div class="popup-list popup-list3">
      <!-- 老师、学生评分 -->
      <gat-popup
        :class="['popup-score', popupActive === 'score' ? 'on' : 'off']"
        :title="scoreTitle"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="UpdateScore($event)"
      >
        <template v-slot:content>
          <el-form ref="submitProject" :model="Project" label-width="100px">
            <el-form-item label="学生自评情况" class="strong-label">
              <label class="require-icon"
                >1.是否已掌握项目实训点及技能点？</label
              >
              <el-input
                type="textarea"
                v-model.trim="projectTask.points"
                :rows="3"
                maxlength="200"
                show-word-limit
                :autosize="false"
                :disabled="userRole != 2 || submitShow"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <label class="require-icon"
                >2.实训项目的预设目标有没有实现？效果如何？</label
              >
              <el-input
                type="textarea"
                v-model.trim="projectTask.presetGoal"
                :rows="3"
                :autosize="false"
                maxlength="200"
                show-word-limit
                :disabled="userRole != 2 || submitShow"
              ></el-input>
            </el-form-item>
            <el-form-item class="el-form-item-three">
              <label class="require-icon"
                >3.您给自己打多少分？（满分100）</label
              >
              <el-input-number
                v-model.trim="projectTask.selfRatedScore"
                :controls="false"
                :min="0"
                :max="100"
                :disabled="userRole != 2 || submitShow"
              ></el-input-number>
            </el-form-item>
            <!-- 老师评分方面 -->
            <el-form-item
              label="老师评价情况"
              class="strong-label"
              v-if="userRole != 2"
            >
              <label class="require-icon">评分：</label>
              <el-input-number
                placeholder="分数"
                v-model.trim="projectTask.score"
                :min="0"
                :max="100"
                :disabled="trainingDetails.status != 2"
                :controls="false"
              ></el-input-number>
            </el-form-item>
            <el-form-item v-if="userRole != 2">
              <label class="require-icon">评语：</label>
              <el-input
                class="score-text"
                placeholder="给学生的评语，学生可在实训报告页面查看"
                v-model.trim="projectTask.appraise"
                type="textarea"
                :readonly="trainingDetails.status != 2"
                :disabled="trainingDetails.status != 2"
                :rows="3"
                :autosize="false"
                show-word-limit
                maxlength="200"
              />
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>

      <!-- 实训报告弹框 -->
      <gat-popup
        :class="['popup-score', popupActive === 'report' ? 'on' : 'off']"
        :title="scoreTitle"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="cancelPopup"
      >
        <template v-slot:content>
          <el-form ref="submitProject" :model="Project" label-width="100px">
            <el-form-item label="学生自评情况" class="strong-label">
              <label class="require-icon"
                >1.是否已掌握项目实训点及技能点？</label
              >
              <el-input
                type="textarea"
                v-model.trim="projectTask.points"
                :rows="3"
                maxlength="200"
                show-word-limit
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item>
              <label class="require-icon"
                >2.实训项目的预设目标有没有实现？效果如何？</label
              >
              <el-input
                type="textarea"
                v-model.trim="projectTask.presetGoal"
                :rows="3"
                maxlength="200"
                show-word-limit
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item class="el-form-item-three">
              <label class="require-icon"
                >3.您给自己打多少分？（满分100）</label
              >
              <el-input-number
                v-model.trim="projectTask.selfRatedScore"
                :controls="false"
                disabled
              ></el-input-number>
            </el-form-item>
            <!-- 老师评分方面 -->
            <el-form-item label="老师评价情况" class="strong-label">
              <label class="require-icon">评分：</label>
              <el-input-number
                placeholder="分数"
                v-model.trim="projectTask.score"
                :controls="false"
                :disabled="!teacherOrStudentState"
              ></el-input-number>
            </el-form-item>
            <el-form-item>
              <label class="require-icon">评语：</label>
              <el-input
                class="score-text"
                placeholder="给学生的评语，学生可在实训报告页面查看"
                v-model.trim="projectTask.appraise"
                type="textarea"
                :rows="3"
                :disabled="!teacherOrStudentState"
                maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
import GatPopup from '@/components/common/GatPopup'
import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js'
import bus from '@/utils/bus'
import { debounce } from 'lodash' // 引入lodash数组函数方法
import { mapGetters } from 'vuex'
export default {
  name: 'SubmitCodeExercise',
  components: {
    GatPopup,
  },
  props: {
    trainingId: {
      type: String,
      default: '',
    },
    studentId: {
      type: String,
      default: '',
    },
    homeWorkStatus: {
      type: Boolean,
      default: false,
    },
    scoreHandle: {
      type: Boolean,
      default: false,
    },
    scoreTitle: {
      type: String,
      default: '',
    },
    trainingDetails: {
      type: Object,
      default() {
        return {
          status: 2,
        }
      },
    },
    Project: {
      type: Object,
      default() {
        return {}
      },
    },
    buildingBlocksTypeObj: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      popupActive: '',
      projectTask: {
        trainingName: '', // 实训名称
        points: '', // 技能点
        presetGoal: '', // 预设目标
        selfRatedScore: '', // 学生自评分数
        score: '', // 老师评分
        appraise: '', // 老师评语
      },
      scoreShow: false,
      submitShow: false,
      teacherOrStudentState: false,
      iconSubmitCode: require('@/assets/images/ai-editor/submit-code.png'),
      iconExercise: require('@/assets/images/ai-editor/submit-exercise.png'),
    }
  },
  computed: {
    ...mapGetters([
      'accountInfo',
      'hasRunSuccess',
      'curriculumId',
      'userRole',
      'running',
    ]),
  },
  watch: {
    homeWorkStatus(val) {
      console.log('homeWorkStatus', val)
    },
    userRole(val) {
      console.log('userRole', val)
    },
  },
  created() {
    let userRole = this.$store.state.userRole;
    // userRole: 1老师，2学生，3校管理员，4超级管理员
    if (userRole === 2) {
      this.teacherOrStudentState = false;
    } else {
      this.teacherOrStudentState = true;
    }
  },

  mounted() {
    this.TrainingReport()
  },
  methods: {
    submitCode: debounce(function(type) {
      // running 为true时，python脚本正在后台运行，需要等python运行结束后才能进行点击
      if (this.running) return
      let userRole = this.userRole
      if (userRole === 2 && this.homeWorkStatus) {
        this.popupActive = 'report'
      } else {
        if (userRole != 2) {
          //老师时，直接提交代码
          this.$parent.saveFile(type)
        } else if (userRole == 2) {
          //学生时，需要弹出自评弹框，然后再提交代码
          this.popupActive = 'score'
          if (this.homeWorkStatus) {
            this.scoreTitle = '实训报告'
          }
          if (this.submitShow) {
            this.scoreTitle = '实训报告'
          }
        }
      }
    }, 500),
    // 实训报告  @data trainingId userId学生id
    async TrainingReport() {
      let { trainingId, studentId } = this,
        userId = studentId || this.accountInfo.userId,
        data = {
          trainingId,
          userId: userId,
        },
        res
      // console.log('data------',)
      res = await MARKCENTER.getTrainingReport(data)
      if (res && res.isSuccess && res.data) {
        this.projectTask = res.data
        // console.log('res.data.score',res.data)
        if (res.data.score) {
          this.$emit('gethomeWorkStatus', true)
        } else {
          this.$emit('gethomeWorkStatus', false)
        }

        // 判断老师是否评分
        if (res.data.score !== null) {
          this.scoreShow = true
        } else {
          this.scoreShow = false
        }
        // 判断学生是否提交
        if (res.data.selfRatedScore !== null) {
          this.submitShow = true
        } else {
          this.submitShow = false
        }
      }
    },
    //点开老师评分弹窗 
    socreProject2() {
      this.popupActive = 'score'
      // if (this.homeWorkStatus) {
      //   this.popupActive = 'report'
      // } else {
      //   this.popupActive = 'score'
      // }
    },
    saveFile(type) {
      this.$emit('saveFile', type)
    },
    // 取消弹窗
    cancelPopup() {
      this.popupActive = ''
      this.scoreForm = ''
    },

    // 正则检验是否为数字类型
    scoreFunction(theObj) {
      var reg = /^[0-9]+\.?[0-9]*$/
      if (reg.test(theObj)) {
        return true
      }
      return false
    },
    // 通过主键进行评分
    async UpdateScore(evt, message) {
      if (this.userRole != 2) {
        // 老师：给学生打分
        let scoreFlag = !this.scoreFunction(this.projectTask.score)
        if (scoreFlag) {
          return this.$message.error('请填写评分！')
        }
        if (!this.projectTask.appraise) {
          return this.$message.error('请完整填写评分内容！')
        }
        let userId = this.accountInfo.userId // 当前用户userId
        let params = {
            score: this.projectTask.score, // 教师评分分数
            appraise: this.projectTask.appraise, // 教师评语
            appraiserId: userId, // 评分人Id
            taskId: this.projectTask.taskId, // 作业id
          },
          msg = message
            ? message
            : { success: '评分成功！', fail: '评分失败！' }

        MARKCENTER.evaluationProByTeacher(params).then((res) => {
          if (res.isSuccess) {
            this.$message.success(msg.success)
            this.popupActive = ''
            this.TrainingReport()
            this.$emit('gethomeWorkStatus', true)
            // this.$parent.getTrainingByTrainingId()
            bus.$emit('getTrainingByTrainingId') //更新实训状态;
          } else {
            this.$message.error(msg.fail)
          }
        })
      } else {
        if (this.submitShow) { // 学生已自评
          return this.popupActive = ''
        }
        // 学生：自我评分
        let scoreFlag = !this.scoreFunction(this.projectTask.selfRatedScore)
        if (
          !this.projectTask.points ||
          !this.projectTask.presetGoal ||
          scoreFlag
        ) {
          return this.$message.error('请完整填写自评相关内容！')
        }
        if (this.projectTask.selfRatedScore > 100) {
          return this.$message.error('评分不能超过满分！')
        }
        //先调用发布作业方法,发布作业成功后在调用自评接口;
        let saveRes = await this.$parent.saveFile(
          this.buildingBlocksTypeObj.homework
        )
        if (!saveRes || !saveRes.isSuccess) {
          this.$message.error('不能重复提交作业')
          return false
        }

        let params = {
            points: this.projectTask.points, // 技能点
            presetGoal: this.projectTask.presetGoal, // 预设目标
            selfRatedScore: this.projectTask.selfRatedScore, // 学生自评分数
            trainingId: this.trainingId, // 实训id
          },
          msg = message
            ? message
            : { success: '评分成功！', fail: '评分失败！' }
        MARKCENTER.saveEvaluation(params).then((res) => {
          if (res.isSuccess) {
            this.$message.success(msg.success)
            this.popupActive = ''
            this.TrainingReport() //重新获取实训报告信息
          } else {
            this.$message.error(msg.fail)
          }
        })
      }
    },
  },

  updated() {},
  activated() {},
}
</script>
<style lang="scss" scoped>
.submit-code-exercise {
  display: flex;
  justify-content: center;
  position: fixed;
  z-index: 8;
  bottom: 33px;
  left: calc(50% - 200px);
  transform: translateX(-50%);
  // width: 100%;
  .submit-btn {
    display: flex;
    align-items: center;
    margin: 0 10px;
    padding: 8px 20px;
    border-radius: 17px;
    background: rgba(52, 84, 164, 0.6);
    font-size: 14px;
    color: #fefeff;
    font-family: Microsoft YaHei;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
      background: rgba(103, 140, 255, 0.6);
    }
    .text {
      margin-left: 10px;
    }
  }
}
.popup-score {
  z-index: 50;
  &.off {
    display: none;
  }
  &::v-deep .popup-inner {
    width: 620px;
    // height: 100%;
    height: 800px !important;
    max-height: 100%;
    .popup-head {
      .title {
        color: #4C88FF;
      }
    }
    .popup-content {
      .el-form {
        width: 90%;
        .el-form-item {
          margin-bottom: 5px;
          &.strong-label {
            margin-top: 20px;
            .el-form-item__label {
              font-weight: 600;
            }
          }
        }
      }
      .el-form-item-three {
        margin-top: 20px;
      }
      // .score-text {
      //   // margin-top: 20px;
      // }
    }
  }
  ::v-deep.popup-inner {
    max-height: 80%;
    height: 800px !important;
    .popup-content {
      padding-top: 20px;
    }
  }
}
.dispermited {
  pointer-events: none;
  opacity: 0.5;
}
</style>
